export function Menu() {
  const menuToggle = document.querySelector(".menu-toggle")
  const menuContainer = document.querySelector(".menu--container")
  const bodyContainer = document.querySelector("body")
  const activeClass = "active"
  const secondaryNav = document.querySelector("ul#block-secondarynav")
  const menuSectionFirst = document.querySelector(".menu-section--first")
  const menuSectionSecond = document.querySelector(".menu-section--second")
  const menuSectionThird = document.querySelector(".menu-section--third")

  const calcDist = () => {
    menuContainer.style.setProperty(
      "--left",
      menuSectionSecond.offsetLeft + "px",
    )
    menuContainer.style.setProperty(
      "--offset",
      menuSectionThird.offsetLeft + "px",
    )

    window.addEventListener("resize", () => {
      menuContainer.style.setProperty(
        "--left",
        menuSectionSecond.offsetLeft + "px",
      )

      menuContainer.style.setProperty(
        "--offset",
        menuSectionThird.offsetLeft + "px",
      )
    })
  }

  const setNavMinHeight = () => {
    if (menuContainer) {
      const navBlock = document.querySelector("#block-navigationdefault")
      if (navBlock) {
        const blockContent = navBlock.querySelector(".block-content")
        if (blockContent) {
          const contentHeight = blockContent.offsetHeight + 20
          menuContainer.style.setProperty(
            "--nav-min-height",
            `${contentHeight}px`,
          )
          navBlock.style.minHeight = `clamp(520px, var(--nav-min-height), 100vh)`
        }
      }
    }
  }

  const updateNavHeightForActiveMenu = () => {
    if (menuContainer) {
      const activeMenuItem = document.querySelector(
        ".menu-item--expanded.active .field__item article a",
      )
      if (activeMenuItem) {
        const contentHeight = activeMenuItem.offsetHeight + 20
        menuContainer.style.setProperty(
          "--nav-min-height",
          `${contentHeight}px`,
        )
      } else {
        // If no active menu, revert to default calculation
        setNavMinHeight()
      }
    }
  }

  // Set initial min-height
  setNavMinHeight()

  // Update on window resize
  window.addEventListener("resize", setNavMinHeight)

  if (secondaryNav) {
    const secondaryNavMobile = secondaryNav.cloneNode(true)
    const secondaryNavMobileBtns =
      secondaryNavMobile.querySelectorAll(".menu-item a")

    if (secondaryNavMobile && secondaryNavMobileBtns) {
      secondaryNavMobile.id = "secondarynav-mobile"
      secondaryNavMobileBtns.forEach((btn, i) => {
        btn.classList.add("btn", i === 0 ? "btn-primary" : "btn-outline")
      })
      menuSectionSecond.prepend(secondaryNavMobile)
    }
  }

  if (menuToggle && menuContainer) {
    menuToggle.onclick = () => {
      menuToggle.classList.toggle(activeClass)
      menuContainer.classList.toggle(activeClass)
      bodyContainer.classList.toggle("menu--open")
    }

    const mainMenu = document.querySelector("#block-mainnavigation")
    const mainMenuItems = mainMenu.querySelectorAll(".menu-item--expanded")

    calcDist()

    mainMenuItems.forEach((element, index) => {
      const menuLink = element.querySelector("button")
      menuLink.onclick = (event) => {
        event.preventDefault()
        mainMenuItems.forEach((element) => {
          menuSectionFirst.classList.add(activeClass)
          mainMenu.classList.add(activeClass)
          bodyContainer.classList.add("sub-is-" + activeClass)
          element.style.setProperty("--top", element.offsetTop + "px")

          if (mainMenuItems[index].classList.contains(activeClass)) {
            menuSectionFirst.classList.remove(activeClass)
            mainMenu.classList.remove(activeClass)
            bodyContainer.classList.remove("sub-is-" + activeClass)
            setNavMinHeight()
            return
          }
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
        })
        element.classList.toggle(activeClass)
        // Update height after toggling active state
        setTimeout(updateNavHeightForActiveMenu, 0)
      }
    })

    document.addEventListener("keyup", (event) => {
      if (event.code === "Escape") {
        if (
          bodyContainer.classList.contains("menu--open") &&
          !bodyContainer.classList.contains("sub-is-active")
        ) {
          menuToggle.classList.remove(activeClass)
          menuContainer.classList.remove(activeClass)
          bodyContainer.classList.remove("menu--open")
        } else if (bodyContainer.classList.contains("sub-is-active")) {
          mainMenuItems.forEach((element) => {
            element.classList.remove(activeClass)
            bodyContainer.classList.remove("sub-is-" + activeClass)
          })
        }
      }
    })
  }
}
